import React from 'react';
import { useDropzone } from 'react-dropzone';
import { lang } from '../../Utils';

const sizeValidator = (file) => {
  let size = Math.round((file.size / 1024));
  let maxSize = 1024 * 10;
  if (size > maxSize) {
    return {
      code: "size-too-large",
      message: `Size is larger than ${maxSize}`
    };
  }

  return null
}

const DropZone = (props) => {

  const { onChange } = props;
  const { onChangeFile } = props;

  const {
    acceptedFiles,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: 'image/gif,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,video/mp4,application/pdf,application/zip',
    maxFiles: 1,
    validator: sizeValidator
  });

  const acceptedFileItems = acceptedFiles.map(file => {
    const reader = new FileReader();
    reader.onload = function (event) {
      const dataUrl = event.target.result.split(';');
      onChange(`${dataUrl[0]};name=${file.name};${dataUrl[1]}`);
      if (!!onChangeFile) onChangeFile(file);
    };
    reader.readAsDataURL(file);

    return <div className="dropzone-file" style={{display:'none'}} key={file.path}>
      {file.path} {Math.round(file.size / 1024)} Kb
    </div>
  })

  return (
    <section className="dropzone-container">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <>
          <p>{lang('Drag n drop some files here, or click to select')}</p>
          <em>{lang('Only *.jpg,*.jpeg,*.png,*.gif,*.doc,*.docx,*.pdf,*.txt,*xls,*.xlsx,*.zip,*.mp4 will be accepted')}</em>
          <em>{lang('Max file size 10Mb')}</em>
        </>
        {acceptedFileItems}
      </div>
    </section>
  );
}

export default DropZone;